import { Form, Input, Button, Card, Typography, message, Alert } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthStore } from '../../stores/authStore';
import LanguageSwitcher from '../../components/layout/LanguageSwitcher';

const { Title } = Typography;

const LoginPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  // const [showRegister, setShowRegister] = useState(false); // 🚫 註冊功能已禁用
  
  const { 
    login, 
    // register, // 🚫 註冊功能已禁用
    isLoading, 
    error, 
    isAuthenticated, 
    clearError 
  } = useAuthStore();

  // 如果已經登錄，重定向到首頁
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (isAuthenticated && token) {
      navigate('/');
    }
  }, [isAuthenticated, navigate]);

  // 清除錯誤信息
  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        clearError();
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [error, clearError]);

  const onFinish = async (values: any) => {
    try {
      // 🚫 註冊功能已禁用，只保留登錄
      await login({
        email: values.email,
        password: values.password
      });
      message.success(t('登錄成功！'));
      const next = new URLSearchParams(window.location.search).get('next');
      navigate(next || '/');
    } catch (error: any) {
      message.error(error.message || t('登錄失敗'));
    }
  };

  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px',
      position: 'relative'
    }}>
      <div style={{ position: 'absolute', top: 16, right: 16, zIndex: 1 }}>
        <LanguageSwitcher />
      </div>
      <Card style={{
        width: '100%', 
        maxWidth: 400, 
        padding: '24px',
        borderRadius: '12px',
        boxShadow: '0 10px 30px rgba(0,0,0,0.1)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '32px' }}>
          <Title level={2} style={{ marginBottom: '8px', color: '#005b96' }}>
            {t('WYNI AI ERP')}
                                </Title>
          <Typography.Text type="secondary">
            {t('歡迎回來')}
                                </Typography.Text>
        </div>

        {error && (
          <Alert
            message={error}
            type="error"
            showIcon
            closable
            onClose={clearError}
            style={{ marginBottom: '16px' }}
          />
        )}

        <Form
          form={form}
          name="login"
          onFinish={onFinish}
          layout="vertical"
          size="large"
        >

          <Form.Item
            name="email"
            rules={[
              { required: true, message: t('請輸入郵箱') },
              { type: 'email', message: t('請輸入有效的郵箱地址') }
            ]}
          >
            <Input
              prefix={<UserOutlined />}
              placeholder={t('郵箱地址')}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[
              { required: true, message: t('請輸入密碼') },
              { min: 6, message: t('密碼至少需要6個字符') }
            ]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder={t('密碼')}
            />
          </Form.Item>


          <Form.Item style={{ marginBottom: '16px' }}>
            <Button 
              type="primary" 
              htmlType="submit" 
              block 
              loading={isLoading}
              style={{
                height: '48px',
                fontSize: '16px',
                fontWeight: '500'
              }}
            >
              {t('登錄')}
                                      </Button>
          </Form.Item>

          <div style={{ textAlign: 'center' }}>
            <Typography.Text type="secondary" style={{ fontSize: '12px' }}>
              {t('需要帳戶？請聯繫管理員')}
                                      </Typography.Text>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default LoginPage; 